import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Editor from '../../Editor';
import FormatBubbleMenu from '../../../menus/FormatBubbleMenu';
import FixedMobileMenu from '../../../menus/FixedMobileMenu/FixedMobileMenu';
import { extConfig } from './config';
import { useEditorContext } from '../../Context';
import viewerStyles from '../../../Viewer/presets/Comment/Comment.scss';
import s from './Comment.scss';
function isChildOfAnyElement(containerElementRefs, target) {
    if (!target) {
        return false;
    }
    let found = false;
    containerElementRefs.forEach((containerElementRef)=>{
        if (found || !(containerElementRef === null || containerElementRef === void 0 ? void 0 : containerElementRef.current)) {
            return;
        }
        if (// If we don't ignore root element focus, this can lead to some issues
        // when our usual implementations collapse their controls and have to dump the user's
        // focus somewhere.
        !containerElementRef.current.isEqualNode(target) && containerElementRef.current.contains(target)) {
            found = true;
            return;
        }
    });
    return found;
}
const CommentMenus = ({ rootElementRef })=>{
    const toolbarRef = useRef(null);
    const [shouldShowMobileMenu, setShouldShowMobileMenu] = useState(false);
    const isMobile = useContext(MobileContext);
    const editor = useEditorContext();
    // Since the mobile toolbar is in a portal, we need to track global focusin and focusout events to determine when it
    // should be shown.
    // We take popper as being a child, this might not be 100% accurate but should be 99%...
    useEffect(()=>{
        if (isMobile && document) {
            const containerElementRefs = [
                rootElementRef,
                toolbarRef
            ];
            const checkAndSetMenuVisibility = (ev)=>{
                var _ev_target;
                const should = isChildOfAnyElement(containerElementRefs, ev.target) || ((_ev_target = ev.target) === null || _ev_target === void 0 ? void 0 : _ev_target.closest('.editor-sub-menu')) !== null;
                setShouldShowMobileMenu(should);
                if (should && shouldShowMobileMenu !== should) {
                    editor === null || editor === void 0 ? void 0 : editor.commands.focus();
                }
            };
            const focusCallback = (ev)=>{
                checkAndSetMenuVisibility(ev);
            };
            const checkOutsideClick = (ev)=>{
                checkAndSetMenuVisibility(ev);
            };
            document.addEventListener('focusin', focusCallback);
            document.addEventListener('touchstart', checkOutsideClick);
            return ()=>{
                document.removeEventListener('focusin', focusCallback);
                document.removeEventListener('touchstart', checkOutsideClick);
            };
        }
    }, [
        rootElementRef,
        isMobile,
        editor === null || editor === void 0 ? void 0 : editor.commands,
        shouldShowMobileMenu
    ]);
    return isMobile && shouldShowMobileMenu ? /*#__PURE__*/ React.createElement(FixedMobileMenu, {
        noAtomics: true,
        ref: toolbarRef,
        className: cn(s['mobile-toolbar'], shouldShowMobileMenu && s['visible'])
    }) : /*#__PURE__*/ React.createElement(FormatBubbleMenu, {
        omitHRule: true
    });
};
const CommentEditor = (_param)=>{
    var { rootElementRef, className } = _param, rest = _object_without_properties(_param, [
        "rootElementRef",
        "className"
    ]);
    const Menu = useCallback(()=>{
        return /*#__PURE__*/ React.createElement(CommentMenus, {
            rootElementRef: rootElementRef
        });
    }, [
        rootElementRef
    ]);
    return /*#__PURE__*/ React.createElement(Editor, _object_spread_props(_object_spread({}, rest), {
        presetId: "comment",
        className: cn(s['root'], viewerStyles['root'], className),
        extensionConfig: extConfig
    }), Menu);
};
CommentEditor.displayName = 'CommentEditor';
export default CommentEditor;

//# sourceMappingURL=Comment.js.map